import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import './../../styles/SupportModal.css';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import getBaseUrl from './../../utils/baseUrl';

function SupportModal({ isOpen, onClose }) {
  const [content, setContent] = useState('');
  const { pathname } = useLocation();
  const androidPaths = ['/android', '/visorid', '/install', '/android-setup'];
  const isAndroidPage = androidPaths.some(p => pathname.toLowerCase().startsWith(p));

  useEffect(() => {
    const handleKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    (async () => {
      try {
        const res = await fetch(`${getBaseUrl()}/support/support-contact-info/support-info.md`);
        if (!res.ok) throw new Error(res.statusText);
        const md = await res.text();
        const html = DOMPurify.sanitize(marked(md));
        setContent(html);
      } catch {
        setContent('<p>Error loading support information. Please try again later.</p>');
        console.error('Error fetching support information');
      }
    })();
  }, [isOpen]);

  if (!isOpen) return null;

  const modal = (
    <div className={isAndroidPage ? 'modal-overlay-android' : 'modal-overlay'} onClick={onClose}>
      <div
        className={isAndroidPage ? 'modal-content-android' : 'modal-content'}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={isAndroidPage ? 'close-button-android' : 'close-button'}
          onClick={onClose}
        >&times;</button>

        <div className="modal-body" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}

export default SupportModal;
